import "./OTPInput.scss"

import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import { ONE_TIME_PASSWORD_NUMBER_INPUTS } from "../../../constants/two-factor-constants"
import { updateFormField } from "../../../redux/actions"
import { generateInputRefs } from "../../../utils/global-utils"
import InputGroup from "../../organisms/InputGroup"

const OTPInput = ({ displayCode = null, readOnly = false }) => {
  const dispatch = useDispatch()
  const inputRefs = generateInputRefs(ONE_TIME_PASSWORD_NUMBER_INPUTS)
  const initialOTPInputs = Array(ONE_TIME_PASSWORD_NUMBER_INPUTS).fill("")

  const [initialOneTimePassword, setInitialOneTimePassword] = useState(initialOTPInputs)

  const { primaryBtnRedux } = useSelector(state => state.forms.formData)

  useEffect(() => {
    if (inputRefs[0].current && !readOnly && !displayCode) {
      inputRefs[0].current.focus()
    }
  }, [readOnly, displayCode])

  // Set display code when provided
  useEffect(() => {
    if (displayCode) {
      const codeArray = displayCode.toString().split("")
      const formattedArray = [...initialOTPInputs]

      // Fill the array with the display code
      codeArray.forEach((digit, index) => {
        if (index < ONE_TIME_PASSWORD_NUMBER_INPUTS) {
          formattedArray[index] = digit
        }
      })

      setInitialOneTimePassword(formattedArray)

      // Update Redux state if we're in input mode (not just display mode)
      if (!readOnly) {
        const totpToken = formattedArray.join("")
        dispatch(updateFormField("totpToken", totpToken))
        dispatch(
          updateFormField("primaryBtnRedux", {
            ...primaryBtnRedux,
            disabled: totpToken.length < ONE_TIME_PASSWORD_NUMBER_INPUTS,
          }),
        )
      }
    }
  }, [displayCode])

  const setInputFocus = (inputDigit, index) => {
    if (inputDigit !== "" && !readOnly) {
      if (index < inputRefs.length - 1) {
        inputRefs[index + 1].current.focus()
      }
    }
  }

  const handleOTPChange = (e, index) => {
    if (readOnly) return

    const inputValue = e.target.value
    const updatedOTP = [...initialOneTimePassword]

    updatedOTP[index] = inputValue
    setInitialOneTimePassword(updatedOTP)
    setInputFocus(inputValue, index)

    const totpToken = updatedOTP.join("")
    dispatch(updateFormField("totpToken", totpToken))
    dispatch(
      updateFormField("primaryBtnRedux", {
        ...primaryBtnRedux,
        disabled: totpToken.length < ONE_TIME_PASSWORD_NUMBER_INPUTS,
      }),
    )
  }

  return (
    <div className="otp-inputs">
      {initialOneTimePassword.map((value, index) => (
        <>
          <div>
            <InputGroup
              noRedux
              hideMaxLength
              type="text"
              maxLength={1}
              inputGroupClassName="otp-input"
              customValue={value}
              onChange={e => handleOTPChange(e, index)}
              inputProps={{
                ref: inputRefs[index],
              }}
              readOnly={readOnly}
            />
          </div>
          {(index + 1) % 3 === 0 && index < initialOneTimePassword.length - 1 && (
            <div className="otp-divider">-</div>
          )}
        </>
      ))}
    </div>
  )
}

// OTPInput.propTypes = {}

export default OTPInput
